import React from 'react';
import { Box, Button, Card, CardContent, Typography } from '@mui/material';
import { Title } from 'react-admin';
import PersonAddIcon from '@mui/icons-material/PersonAdd';

const FieldSignUpPage: React.FC = () => {
    return (
        <Box sx={{ p: 3, maxWidth: 800, mx: 'auto' }}>
            <Title title="Field Sign Up" />
            <Typography variant="h4" gutterBottom>
                Field Sign Up
            </Typography>
            <Typography variant="body1" color="textSecondary" sx={{ mb: 4 }}>
                Register a new homeowner in the field
            </Typography>

            <Card sx={{ mb: 3 }}>
                <CardContent>
                    <Typography variant="h6" gutterBottom>
                        New Homeowner
                    </Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
                        Start the full field sign-up process to register a new homeowner with a sign.
                    </Typography>
                    <Button
                        variant="contained"
                        href="#/field-signup"
                        startIcon={<PersonAddIcon />}
                        size="large"
                    >
                        Start Field Sign-Up
                    </Button>
                </CardContent>
            </Card>
        </Box>
    );
};

export default FieldSignUpPage;
